<template>
  <div></div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Content } from '@forchange/storytime';
import confetti from 'canvas-confetti';

@Component
export default class EasterEgg extends Vue {
  @Prop({ type: Object }) content!: Content & { occured?: boolean };

  mounted() {
    if (!this.content.occured) {
      this.confetti();
      window.storyteller.updateContent((content) => ({
        occured: true
      }));
    }
  }

  // from: https://www.kirilv.com/canvas-confetti/#realistic
  confetti() {
    const count = 200;
    const defaults = {
      origin: { y: 0.7 }
    };

    function fire(particleRatio: number, opts: confetti.Options) {
      confetti({
        ...defaults,
        ...opts,
        ...{
          particleCount: Math.floor(count * particleRatio)
        }
      });
    }

    fire(0.25, {
      spread: 26,
      startVelocity: 55
    });

    fire(0.2, {
      spread: 60
    });

    fire(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8
    });

    fire(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2
    });

    fire(0.1, {
      spread: 120,
      startVelocity: 45
    });
  }
}
</script>
